import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasLiveSession } from "../helpers/global";

/**
 * Portal pages that need the portal session (e.g. connecting Messenger).
 * Without one: to the login page, which brings the user back here.
 */
const PrivateRoute = ({ children }) => {
  const location = useLocation();

  if (hasLiveSession()) {
    return children;
  }

  const next = encodeURIComponent(location.pathname + location.search);

  return <Navigate to={`/login?next=${next}`} replace />;
};

export default PrivateRoute;
